import { ToolbarButton as t } from "../../styles.js";
import { styled as o } from "styled-components";
import { MediaQuery as i } from "../../../../styles/variables.js";
const a = o(t)`
  #toolbar && {
    display: none;

    @media ${i.SCREEN_MD_UP} {
      display: flex;
    }
  }
`, l = o.div`
  position: absolute;
  z-index: 1;
  left: 160px;

  .epr-emoji-category {
    list-style: none !important;
  }
`;
export {
  l as EmojiPickerContainer,
  a as ToolbarButtonEmoji
};
